import cn from 'classnames'
import React, { ComponentProps } from 'react'
import { useTranslate } from 'src/localization/Trns'

type MccWholesaleIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function MccWholesaleIcon(props: MccWholesaleIconProps) {
  const translate = useTranslate()
  const { className = '', ['aria-label']: ariaLabel, ...rest } = props
  return (
    <svg
      className={cn('MccWholesaleIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={ariaLabel ?? translate('Wholesale')}
      {...rest}
    >
      <path
        d="M12.6666 4.85173L6.99998 7.99987M6.99998 7.99987L1.33331 4.85173M6.99998 7.99987L7 14.3332M13 10.7056V5.29419C13 5.06576 13 4.95155 12.9663 4.84968C12.9366 4.75956 12.8879 4.67684 12.8236 4.60705C12.7509 4.52816 12.651 4.47269 12.4514 4.36176L7.51802 1.62102C7.32895 1.51598 7.23442 1.46346 7.1343 1.44287C7.0457 1.42464 6.95431 1.42464 6.8657 1.44287C6.76559 1.46346 6.67105 1.51598 6.48198 1.62102L1.54865 4.36176C1.34896 4.47269 1.24912 4.52816 1.17642 4.60705C1.11211 4.67684 1.06343 4.75957 1.03366 4.84968C1 4.95155 1 5.06576 1 5.29419V10.7056C1 10.934 1 11.0482 1.03366 11.1501C1.06343 11.2402 1.11211 11.3229 1.17642 11.3927C1.24912 11.4716 1.34897 11.5271 1.54865 11.638L6.48198 14.3788C6.67105 14.4838 6.76559 14.5363 6.8657 14.5569C6.95431 14.5751 7.0457 14.5751 7.1343 14.5569C7.23442 14.5363 7.32895 14.4838 7.51802 14.3788L12.4514 11.638C12.651 11.5271 12.7509 11.4716 12.8236 11.3927C12.8879 11.3229 12.9366 11.2402 12.9663 11.1501C13 11.0482 13 10.934 13 10.7056Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
